import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import "./DashboardpagesCss/HomeCollectionHistory.css";
import noDataFound from "../../Assets/noDataFound.png";
import { getBookingHistory, getProfileStatus } from "../../api/api";
import toast from "react-hot-toast";
import { getUserMobile } from "../../utils/auth";
import { formatDate } from "../../utils/helper";
import { FaEye } from "react-icons/fa";

const HomeCollectionHistory = () => {
  const { members } = useOutletContext();

  const [member, setMember] = useState("");

  // default dates: `toDate` = today, `fromDate` = one month prior
  const formatDateChange = (d) => {
    const pad = (n) => String(n).padStart(2, "0");
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  const today = new Date();
  const oneMonthAgo = new Date(today);
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  const [fromDate, setFromDate] = useState(formatDateChange(oneMonthAgo));
  const [toDate, setToDate] = useState(formatDateChange(today));
  const [data, setData] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [profileData, setProfileData] = useState([]);

  const demoData = [
    {
      member: "Ankit Poddar",
      date: "2025-09-10",
      test: "Blood Test - Sugar",
      status: "Completed",
    },
    {
      member: "Priya Poddar",
      date: "2025-09-15",
      test: "Lipid Profile",
      status: "Pending",
    },
    {
      member: "Ankit Poddar",
      date: "2025-09-20",
      test: "Vitamin D Test",
      status: "Completed",
    },
    {
      member: "fdf",
      date: "2025-09-10",
      test: "Blood Test - Sugar",
      status: "Completed",
    },
    {
      member: "we",
      date: "2025-09-15",
      test: "Lipid Profile",
      status: "Pending",
    },
    {
      member: "our",
      date: "2025-09-20",
      test: "Vitamin D Test",
      status: "Completed",
    },
  ];

  useEffect(() => {
    fetchProfileListData();
  }, []);

  const fetchProfileListData = async () => {
    try {
      // 🧾 Prepare API payload
      const mobile = getUserMobile();
      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: "",
        mobile_no: mobile,
      };

      console.log("Profile check payload:", payload);

      // 📡 API call
      setLoading(true);
      const response = await getProfileStatus(payload);
      console.log("Profile Status Response:", response);

      if (response?.data?.status === "success") {
        setProfileData(response.data.data || {});
      } else {
        console.error("Profile fetch failed:", response?.data?.message);
        toast.error(response?.data?.message || "Unable to fetch profile data");
      }
    } catch (error) {
      console.error("Unexpected error fetching profile data:", error);
      toast.error("Something went wrong while loading your profile.");
    } finally {
      setLoading(false);
    }
  };

  

  const handleSearch = async () => {
    try {
      setLoading(true);

      const mobile = getUserMobile();

      const payload = {
        RBAuthKey: "RBDWAh!Q1s74e",
        user_id: member || "",
        From_date: formatDate(fromDate),
        To_date: formatDate(toDate),
       
      };

      console.log("Booking history payload:", payload);

      const response = await getBookingHistory(payload);
      console.log("Booking history response:", response);

      if (response?.data?.status === "success") {
        const respData = response.data.data || [];
        setData(respData);
        setShowAll(false);
      } else {
        // handle API returning non-success status
        console.warn("Booking history fetch failed:", response?.data?.message);
        toast.error(response?.data?.message || "No booking history found");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching booking history:", error);
      toast.error("Something went wrong while fetching booking history.");
      setData([]);
    } finally {
      setLoading(false);
    }
  };
const handleView = (appointmentId, userId) => {
  const redirectUrl = `https://rbdiagnostic.com/hcupdate/#/hcrequestedit/${appointmentId}/${userId}/s`;
  window.location.href = redirectUrl;
};


  return (
    <div className="container">
      <div className="profile-header">
        <h2 className="rb-title pk-title package-tagg">HC Booking History</h2>
      </div>

      <div className="edit-profile-form-wrapper">
        <div className="collection-history d-flex flex-wrap gap-3 align-items-end">
          <div className="date-row">
            <label className="form-label collection-label">Choose Member</label>
            <select
              value={member}
              onChange={(e) => setMember(e.target.value)}
              className="form-select select-form-view"
              style={{ cursor: "pointer" }}
            >
              <option value="">-- Select Member --</option>
              {profileData.map((m, index) => (
                <option key={index} value={m.user_id}>
                  {m.PFirstName} {m.PLastName}
                </option>
              ))}
            </select>
          </div>

          <div className="date-row">
            <label className="form-label collection-label">From Date*</label>
            <input
              type="date"
              className="form-control date-input"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="date-row">
            <label className="form-label collection-label">To Date*</label>
            <input
              type="date"
              className="form-control date-input"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="btn-group-history">
            <button className="view-dash-btn" onClick={handleSearch}>
              <span className="btn-text">Search</span>
            </button>
          </div>
        </div>

      <div className="history-area">
          {loading ? (
            <p style={{ textAlign: "center" }}>Loading...</p>
          ) : data.length === 0 ? (
            <div className="no-data">
              <img src={noDataFound} alt="No Data Found" />
              <p>No booking history found</p>
            </div>
          ) : (
            <table className="booking-table">
              <thead>
                <tr>
                  <th>Sl. No</th>
                  <th>Appointment ID</th>
                  <th>Appointment Date</th>
                  <th>Appointment Time</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.Appointment_ID || "—"}</td>
                    <td>{item.app_date || "—"}</td>
                    <td>{item.app_time || "—"}</td>
                    <td>
                      <button
                        className="eye-btn"
                        onClick={() => handleView(item.Appointment_ID, item.user_id)}
                        title="View Details"
                      >
                        <FaEye />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomeCollectionHistory;
